// extracted by css-extract-rspack-plugin
export default {"fraudAnalysisContainer":"DomainVerification_fraudAnalysisContainer__U5yRL","fraudList":"DomainVerification_fraudList__UHph5"};